import { Stack, Alert, TextField } from '@mui/material';
import FeedbackTypePicker from './FeedbackTypePicker';
import ScreenshotCapture from './ScreenshotCapture';
import SubmissionDetailsAccordion from './SubmissionDetailsAccordion';


export function FeedbackFormFields({
  type,
  onTypeChange,
  title,
  onTitleChange,
  description,
  onDescriptionChange,
  errorMessage,
  onClearError,
  submitting,
  fileInputRef,
  screenshotFile,
  screenshotPreview,
  onFileChange,
  onRemoveScreenshot,
  onSubmit,
  userName,
  userEmail,
  userPhone,
  userRole,
  accountId,
  linkedAccountIds,
  route,
  environment,
}) {
  const helperText =
    type === 'bug'
      ? 'What did you do, what happened, what did you expect? If it\'s on a specific athlete or program, name them.'
      : 'What would you like to be able to do, and why? How would it help you or your family?';

  return (
    <Stack spacing={2.5} component="form" onSubmit={onSubmit}>
      {errorMessage && (
        <Alert severity="error" onClose={onClearError}>
          {errorMessage}
        </Alert>
      )}

      <FeedbackTypePicker
        type={type}
        onChange={onTypeChange}
        disabled={submitting}
      />

      <TextField
        label="Title"
        placeholder={type === 'bug' ? 'e.g. Schedule tab fails to load on mobile' : 'e.g. Ability to download roster as CSV'}
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        required
        fullWidth
        size="small"
        helperText={`${title.length}/200`}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: { xs: '16px', sm: 'inherit' },
          },
        }}
        slotProps={{
          inputLabel: {
            sx: { bgcolor: 'background.paper', px: 0.5 },
          },
          formHelperText: {
            sx: { textAlign: 'right', color: 'text.secondary', mt: 0.5 },
          },
          htmlInput: { maxLength: 200, 'aria-label': 'Report title' },
        }}
      />

      <TextField
        label="Description"
        placeholder="Please provide details..."
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        required
        fullWidth
        multiline
        rows={4}
        helperText={`${helperText} (${description.length}/5000)`}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: { xs: '16px', sm: 'inherit' },
          },
        }}
        slotProps={{
          inputLabel: {
            sx: { bgcolor: 'background.paper', px: 0.5 },
          },
          formHelperText: {
            sx: { fontStyle: 'italic', color: 'text.secondary', mt: 0.5 },
          },
          htmlInput: { maxLength: 5000, 'aria-label': 'Report description' },
        }}
      />

      <ScreenshotCapture
        fileInputRef={fileInputRef}
        screenshotFile={screenshotFile}
        screenshotPreview={screenshotPreview}
        onFileChange={onFileChange}
        onRemoveScreenshot={onRemoveScreenshot}
        disabled={submitting}
      />

      <SubmissionDetailsAccordion
        userName={userName}
        userEmail={userEmail}
        userPhone={userPhone}
        userRole={userRole}
        accountId={accountId}
        linkedAccountIds={linkedAccountIds}
        route={route}
        environment={environment}
      />
    </Stack>
  );
}
